export const getBase64 = async (uri) => {
  // 1. Handle the async fetch and blob conversion naturally
  const response = await fetch(uri);
  if (!response.ok) throw new Error(`Fetch failed: ${response.statusText}`);
  
  const blob = await response.blob();

  // 2. Wrap only the callback-based FileReader in a Promise
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onloadend = () => {
      const result = reader.result;
      const base64Clean = result.split(",")[1];
      resolve(base64Clean);
    };

    reader.onerror = () => {
      reject(new Error("FileReader failed to read blob"));
    };

    reader.readAsDataURL(blob);
  });
};